/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { FeeType } from './FeeType';
import {
    FeeTypeFromJSON,
    FeeTypeFromJSONTyped,
    FeeTypeToJSON,
    FeeTypeToJSONTyped,
} from './FeeType';

/**
 * 
 * @export
 * @interface FeeLine
 */
export interface FeeLine {
    /**
     * 
     * @type {number}
     * @memberof FeeLine
     */
    amount: number;
    /**
     * 
     * @type {FeeType}
     * @memberof FeeLine
     */
    feeType: FeeType;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof FeeLine
     */
    classId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof FeeLine
     */
    seasonId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof FeeLine
     */
    studentId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof FeeLine
     */
    locationId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof FeeLine
     */
    description?: string | null;
}



/**
 * Check if a given object implements the FeeLine interface.
 */
export function instanceOfFeeLine(value: object): value is FeeLine {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('feeType' in value) || value['feeType'] === undefined) return false;
    return true;
}

export function FeeLineFromJSON(json: any): FeeLine {
    return FeeLineFromJSONTyped(json, false);
}

export function FeeLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeeLine {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'feeType': FeeTypeFromJSON(json['feeType']),
        'classId': json['classId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'seasonId': json['seasonId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['seasonId']),
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function FeeLineToJSON(json: any): FeeLine {
    return FeeLineToJSONTyped(json, false);
}

export function FeeLineToJSONTyped(value?: FeeLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'feeType': FeeTypeToJSON(value['feeType']),
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'seasonId': ActorActivityRecordActorUserIdToJSON(value['seasonId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'description': value['description'],
    };
}

